import { faker } from '@faker-js/faker';

export const fakePhoneNumber = (pattern: RegExp = /[0-9]{3}-[0-9]{3}-[0-9]{4}/) => faker.helpers.fromRegExp(pattern);
